export default __webpack_public_path__ + "static/media/before@2x.a21e8aeb.png";